import { useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CellCreatedOn, CellQuantAnalysisName, CellProject, CellOwner } from '../Cells';

export default function useQuantAnalysesTableColumns() {
  const isDesktop = useMediaQuery('(min-width:900px)');


  return useMemo(() => [
    {
      accessor: 'name',
      id: 'name',
      Header: 'Name',
      Cell: CellQuantAnalysisName,
      minWidth: 150,
    },
    isDesktop ? {
      accessor: 'project',
      id: 'project',
      Header: 'Project',
      Cell: CellProject,
      minWidth: 350,
      maxWidth: 1,
    } : null,
    isDesktop ? {
      accessor: 'owner',
      id: 'owner',
      Header: 'Owner',
      Cell: CellOwner,
      width: 80,
    } : undefined,
    isDesktop ? {
      accessor: 'createdOn',
      id: 'createdOn',
      Header: 'Created On',
      Cell: CellCreatedOn,
      minWidth: 80,
      width: 80,
    } : undefined,
  ].filter(Boolean), [isDesktop]);
}

export { useQuantAnalysesTableColumns };